/**
 * A wrapper around the kendo datasource that handles error conditions and server side filtering,paging, and sorting
 *
 * It enhances the transport.parameterMap config property to take an extra property: "default".  When set to
 * default the parameterMap will operate in the standard way that the docfinity api expects for sorting,paging,filtering and create/update/deletes
 *
 * It adds a parameter serverPagingConfig.  Defaults to false.  When set to true, it configures schema.data and schema.total
 *
 * serverGroupingConfig. Defaults to false.  When set to true, it configures schema.groups to match the standard grouping result
 *
 * It accepts an extra config property for error handling: localErrors.
 * This defaults to false.  When set to true, all ajax errors that would normally publish a
 * global message will trigger an event on the datasource instead;
 *
 * Adds a method getExpanded that takes in a single data item and a callback.  Uses the transport properties to find the GET request that will
 * give it the /{url} call, make that call, and call the callback with the expanded version of that data item
 */
import Fast from "common/framework/FastDataSourceMixin";
import ErrorInit from "common/framework/DataSourceErrorInitMixin";
import Core from "common/framework/DataSourceMixin";

export default kendo.data.DataSource.extend(Fast).extend(ErrorInit).extend(Core).extend({
    super: kendo.data.DataSource,
    get(id) {
        const noVirtualPagingResult = kendo.data.DataSource.fn.get.apply(this, arguments);
        if(noVirtualPagingResult === undefined) {
            //in theory this could cause a duplicate search, however its really unlikely to call get() for an item that doesn't exist
            //The most likely reason to end up here is that virtual paging is in play and the sought item doesn't exist on the current page
            //The kendo datasource doesn't actually have documented/supported methods to do virtual paging
            //so this uses totally undocumented virtual paging data structures on the datasource.
            for(let range = 0; range < this._ranges.length; range++) {
                for(let i = 0; i < this._ranges[range].data.length; i++) {
                    if(this._ranges[range].data[i].id == id) {
                        return this._ranges[range].data[i];
                    }
                }
            }
        }
        return noVirtualPagingResult
    }
});
